import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { CommonModule } from '@angular/common';

import { PinnaklIconComponent } from '@pinnakl/shared/ui/icons';

import { TooltipModule } from 'primeng/tooltip';
import { observeControl } from '../../forms';

@Component({
  selector: 'prime-label-content',
  imports: [PinnaklIconComponent, CommonModule, TooltipModule],
  templateUrl: './label-content.component.html',
  styleUrls: ['./label-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabelContentComponent {
  readonly control = input.required<AbstractControl>();

  readonly disabled = input<boolean>(false);
  readonly requirementOverride = input<boolean | null>(null);
  readonly label = input.required<string>();
  readonly styleClass = input('');
  readonly exclamationMessage = input('');
  readonly verticalAlignment = input(true);

  get controlRequired(): boolean {
    return !!(this.requirementOverride() != null
      ? this.requirementOverride()
      : this.control()?.validator?.({} as AbstractControl)?.['required']);
  }

  get controlDisabled(): boolean {
    return this.control()?.disabled || this.disabled();
  }

  get controlInvalid(): boolean {
    return this.control()?.invalid && this.control()?.dirty;
  }

  constructor() {
    observeControl(this.control);
  }
}
